import React, {useEffect, useState} from "react";

// Styles
import ForecastsContainer from "./Forecasts.styles";

// Components
import Tabs from "components/Common/Tabs/Tabs";
import ScenarioSelectionTab from "components/Screens/Fees/Forecasts/ScenarioSelectionTab/ScenarioSelectionTab";
import EditScenariosTab from "components/Screens/Fees/Forecasts/EditScenariosTab/EditScenariosTab";

// Context
import {FeesReportDetails, setFeesReportDetails} from "../../../utils/fees.utils";
import PowerBIDashboard from "../../../components/Common/PowerBIDashboard";

export default function FeesForecasts() {
    const [feesForcastReportDetails, setFeesForcastReportDetails] =
        useState<FeesReportDetails>({ workspaceId: "", reportId: "" });

    useEffect(() => {
        setFeesReportDetails("FORECAST_REPORT", setFeesForcastReportDetails);
    }, []);

    return (
        <ForecastsContainer className={"pageContainer"}>
            <p className={"sectionTitle"}>FORECASTS</p>

            <Tabs
                defaultTab="all_scenarios"
                tabs={[
                    {
                        value: "all_scenarios",
                        title: "ALL SCENARIOS",
                        permissions: ["p_can_view_fees", "p_can_action_fees"],
                        content: (
                            <div className="iframeContainer">
                                {feesForcastReportDetails.reportId && (
                                    <PowerBIDashboard
                                        reportId={
                                            feesForcastReportDetails.reportId
                                        }
                                        workspaceId={
                                            feesForcastReportDetails.workspaceId
                                        }
                                    ></PowerBIDashboard>
                                )}
                            </div>
                        ),
                    },
                    {
                        value: "scenario_selection",
                        title: "NEW SCENARIO",
                        permissions: ["p_can_view_fees", "p_can_action_fees"],
                        content: <ScenarioSelectionTab />,
                    },
                    {
                        value: "edit_scenarios",
                        title: "EDIT SCENARIOS",
                        permissions: ["p_can_view_fees", "p_can_action_fees"],
                        content: <EditScenariosTab />,
                    },
                    // {
                    //     value: "reports",
                    //     title: "REPORTS",
                    //     permissions: ["p_can_view_fees", "p_can_action_fees"],
                    //     content: <ReportsTab />,
                    // },
                ]}
            />
        </ForecastsContainer>
    );
}
